<div class="mat-elevation-z0">
  <div class="content-card">
    <mat-table class="collections-table p-24 py-0" #table [dataSource]="feedbacks">

      <ng-container matColumnDef="index">
        <mat-header-cell *matHeaderCellDef >{{ translationScope+ '.feedback_table.id' | transloco }}
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let i=index"> {{ i+1 }} </mat-cell>
      </ng-container>

      <!-- Feedback Description Column -->
      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef >{{ translationScope+ '.feedback_table.description' | transloco }}
        </mat-header-cell>
        <mat-cell *matCellDef="let feedback">
          {{feedback?.description || '' }}
        </mat-cell>
      </ng-container>

      <!-- Feedback Create Time Column -->
      <ng-container matColumnDef="created">
        <mat-header-cell *matHeaderCellDef >{{ translationScope+ '.feedback_table.created_at' | transloco }}
        </mat-header-cell>
        <mat-cell *matCellDef="let feedback">
          {{feedback?.created | date:'yyyy-MM-dd HH:mm:ss' || '' }}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

      <mat-row *matRowDef="let feedback; columns: displayedColumns"
               class="collection">
      </mat-row>
    </mat-table>
  </div>
</div>
